<div class="text-center">
  <p class="fs-5 mb-4">
    {{ data.message }}
  </p>
  <div class="d-flex justify-content-between">
    <button *ngIf="hasCancel" class="btn btn-outline-secondary px-4 py-2 mr-2" (click)="onCancel()">Abbrechen</button>
    <button *ngIf="hasConfirm" class="btn btn-success px-4 py-2" (click)="onConfirm()">Bestätigen</button>
  </div>
</div>
